import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { HTML_ATTRIBUTE_INLINE_STYLE, HTML_TAG_CONSENT_SCRIPT } from ".";
/**
 * Put an prepared inline style (tag containing a `consent-inline-style` attribute) to the DOM.
 */

function putStyleInlineToDom(_x) {
  return _putStyleInlineToDom.apply(this, arguments);
}

function _putStyleInlineToDom() {
  _putStyleInlineToDom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
    var inlineStyle, inlineStyleHtml;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Get the inline style itself
            inlineStyle = node.getAttribute(HTML_ATTRIBUTE_INLINE_STYLE);
            node.removeAttribute(HTML_ATTRIBUTE_INLINE_STYLE); // Transform the tag to the `style`
            // We need to make such a hacky way because regex does not work and `outerHTML` has also some issues...

            inlineStyleHtml = node.outerHTML.substr(HTML_TAG_CONSENT_SCRIPT.length + 1);
            inlineStyleHtml = inlineStyleHtml.substr(0, inlineStyleHtml.length - HTML_TAG_CONSENT_SCRIPT.length - 3);
            inlineStyleHtml = inlineStyleHtml.replace(new RegExp("type=\"application/consent\""), "");
            inlineStyleHtml = "<style ".concat(HTML_ATTRIBUTE_INLINE_STYLE, "=\"1\" ").concat(inlineStyleHtml).concat(inlineStyle, "</style>"); // add inline attribute so `applyStyleRules` can check one more time for blocked URLs

            node.parentElement.replaceChild(new DOMParser().parseFromString(inlineStyleHtml, "text/html").querySelector("style"), node);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _putStyleInlineToDom.apply(this, arguments);
}

export { putStyleInlineToDom };